export const WHATSAPP_NUMBER = '919158186936'
export const PICKUP_LOCATION = 'https://maps.app.goo.gl/THMrBe64SngLEn2J8'

// Column widths chosen so a row stays within ~32 characters, which is what
// WhatsApp's monospace block shows on a phone without wrapping.
const COL_NO = 3
const COL_NAME = 15
const COL_QTY = 4
const COL_AMOUNT = 10
const TABLE_WIDTH = COL_NO + COL_NAME + COL_QTY + COL_AMOUNT

const money = value => `₹${Math.round(value).toLocaleString('en-IN')}`

const row = (no, name, qty, amount) =>
  no.padEnd(COL_NO) + name.padEnd(COL_NAME) + qty.padStart(COL_QTY) + amount.padStart(COL_AMOUNT)

// Long names wrap onto continuation lines instead of being cut off.
function wrapText(text, width) {
  const lines = []
  let line = ''

  for (const word of String(text).split(/\s+/)) {
    const candidate = line ? `${line} ${word}` : word

    if (candidate.length <= width) {
      line = candidate
      continue
    }

    if (line) lines.push(line)
    line = word.length > width ? word.slice(0, width) : word
  }

  if (line) lines.push(line)
  return lines.length ? lines : ['']
}

function buildTable(items) {
  const rule = '-'.repeat(TABLE_WIDTH)
  const lines = [row('#', 'ITEM', 'QTY', 'AMOUNT'), rule]

  items.forEach((item, index) => {
    const [firstLine, ...restLines] = wrapText(item.name, COL_NAME)

    lines.push(row(
      `${index + 1}.`,
      firstLine,
      `x${item.quantity}`,
      money(item.price * item.quantity)
    ))
    restLines.forEach(line => lines.push(' '.repeat(COL_NO) + line))
    lines.push(' '.repeat(COL_NO) + item.variantLabel)
  })

  const total = items.reduce((sum, item) => sum + item.price * item.quantity, 0)
  lines.push(rule, 'TOTAL'.padEnd(TABLE_WIDTH - COL_AMOUNT) + money(total).padStart(COL_AMOUNT))

  return lines.join('\n')
}

export function buildOrderMessage(items, checkout) {
  const lines = [
    '*CHER — NEW ORDER*',
    '',
    '```',
    buildTable(items),
    '```',
    '',
    `*Order type:* ${checkout.deliveryOption === 'delivery' ? 'Delivery in Panjim' : 'Store pickup'}`,
    checkout.deliveryOption === 'delivery'
      ? `*Deliver to:* ${checkout.mapsLink || 'To be shared'}`
      : `*Pickup at:* ${PICKUP_LOCATION}`,
    `*Preferred time:* ${checkout.deliveryDateTime || 'Flexible'}`
  ]

  if (checkout.isGift) {
    lines.push(`*Gift note:* ${checkout.giftMessage || 'No note'}`)
  }

  return lines.join('\n')
}

export function createWhatsAppLink(items, checkout) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(buildOrderMessage(items, checkout))}`
}
